// extracted by mini-css-extract-plugin
export default {"banner":"importBanner_banner__AEGPF","bannerText":"importBanner_bannerText__hnlUW","buttonImport":"importBanner_buttonImport__k8BfY"};